import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { getPaymentHistoryList } from './../../utils/APIClient'
import moment from 'moment'
import DataTable, { createTheme } from "react-data-table-component";
import { createThemeData, customStyles } from './../../utils/Constants'
const PaymentHistory = () => {
    document.title = "Callingo | Payment History"
    const today = moment().format('YYYY-MM-DD');
    const oneMonthAgo = moment().subtract(1, 'months').format('YYYY-MM-DD');
    const [startDate, setStartDate] = useState(oneMonthAgo);
    const [endDate, setEndDate] = useState(today);
    const [ActivityLog, setActivityLog] = useState([])
    const [totalPages, settotalPages] = useState()
    const [page_size, setpage_size] = useState(10)
    const [page_number, setpage_number] = useState(1)
    const [type, setType] = useState('date_wise');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    createTheme('solarized', createThemeData, 'dark');
    const columns = [
        {
            name: "Sr.No",
            selector: (row, i) => i,
            cell: (row, i) => i + 1,
        },
        {
            name: "Invoice Number",
            selector: (row) => row.invoice_number,
            cell: row => row.invoice_number,
        },
        {
            name: "Plan Name",
            selector: (row) => row.plan_name,
            cell: row => row.plan_name,
        },
        {
            name: "Amount",
            selector: (row) => row.invoice_amount,
            cell: row => row.invoice_amount,
        },
        {
            name: "Invoice Date",
            selector: (row) => row.plan_expiry_date,
            cell: row => row.invoice_date + "" + row.plan_expiry_date,
        },
        {
            name: "Status",
            selector: (row) => row.invoice_status,
            cell: row => (<span class="badge rounded-pill p-1 px-2 bg-success ">{row.invoice_status}</span>),
        },
        {
            name: "Action",
            selector: (row) => row.Duration,
            cell: row => (
                <button className="nav-link mx-auto" onClick={() => navigate('/invoice', { state: { invoice_id: row.invoice_id } })}>
                    <i className="ri-eye-line fs-22"></i>
                </button>
            ),
        },

    ]
    const handlePageChange = page => {
        getCallingoActivity(page_size, page, type, startDate, endDate)
        setpage_number(page);
    };

    const handlePerRowsChange = async (newPerPage, page = page_number) => {
        getCallingoActivity(newPerPage, page, type, startDate, endDate)
        setpage_size(newPerPage);
    };
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };

    const getCallingoActivity = async (
        pagesize,
        pagenumber,
        types = type,
        from_date = startDate,
        to_date = endDate
    ) => {
        setType(types);
        setpage_size(pagesize);
        setLoading(true);

        let request = {
            type: types,
            per_page: pagesize,
            page: pagenumber
        };

        // Add from_date and to_date only when filtering by date
        if (types === "date_wise") {
            request.from_date = moment(from_date).format("DD-MM-YYYY");
            request.to_date = moment(to_date).format("DD-MM-YYYY");
        }

        try {
            let ActivityLog = await getPaymentHistoryList(request);
            if (ActivityLog.data) {
                setActivityLog([...ActivityLog.data.results.data]);
                settotalPages(ActivityLog.data.results.pagination.total_items);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCallingoActivity(page_size, page_number)
    }, [])

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <h4 className="page-title lh-1 mb-3">Payment History</h4>
                    </div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-12">
                    <div className="d-flex align-items-center gap-3 flex-wrap justify-content-between">
                        <div className="app-search ">
                            <form>
                                <div className="input-group">
                                    <input type="search" className="form-control search-form" placeholder="Search by Invoice Number" id="top-search" />
                                    <span className="ri-search-line search-icon"></span>
                                </div>
                            </form>
                        </div>
                        <div className="d-flex align-items-center gap-3 flex-wrap">
                            <p className="text-nowrap mb-0">Select Range</p>
                            <div className="input-group date-input">
                                <input
                                    type="date"
                                    className="form-control shadow form-control-custom border-0"
                                    max={endDate}
                                    value={startDate}
                                    onChange={(e) => {
                                        setStartDate(e.target.value);
                                        if (e.target.value) {
                                            getCallingoActivity(page_size, page_number, "date_wise", e.target.value, endDate);
                                        }
                                    }}
                                />
                            </div>
                            <p className="text-nowrap mb-0">to</p>
                            <div className="input-group date-input">
                                <input
                                    type="date"
                                    className="form-control shadow form-control-custom border-0"
                                    max={endDate}
                                    value={endDate}
                                    onChange={(e) => {
                                        setEndDate(e.target.value);
                                        if (e.target.value) {
                                            getCallingoActivity(page_size, page_number, "date_wise", startDate, e.target.value);
                                        }
                                    }}
                                />
                            </div>

                            <div className="d-flex justify-content-start gap-2">
                                <button onClick={() => getCallingoActivity(page_size, page_number, "date_wise", startDate, endDate)} type="button" className="btn btn-outline-success">Apply Now</button>
                                <button onClick={() => getCallingoActivity(page_size, page_number, "current_month")} type="button" className="btn btn-outline-primary  ">Current Month</button>
                                <button onClick={() => getCallingoActivity(page_size, page_number, "last_3_month")} type="button" className="btn btn-outline-warning ">Last 3 month</button>
                                <button onClick={() => getCallingoActivity(page_size, page_number, "last_6_month")} type="button" className="btn btn-outline-primary  ">Last 6 Month</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-3">
                {loading ? <div className="text-center">   <div className="spinner-border text-success m-2" role="status"></div></div> :

                    <DataTable
                        columns={columns}
                        fixedHeader

                        persistTableHead
                        data={ActivityLog}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPages}
                        paginationDefaultPage={page_number}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        paginationPerPage={page_size}

                        theme="solarized"
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />}


            </div>
        </div>
    );
}

export default PaymentHistory;